<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-data-table
            :headers="headers"
            :items="webpages"
            sort-by="webpageid"
            class="elevation-1"
            :loading="loading"
            loading-text="Loading... Please wait"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Web Page</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on"
                      >New WebPages</v-btn
                    >
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="headline">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.webpagename"
                              label="WebPage Name"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.webpageurl"
                              label="WebPage URL"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.webpageicon"
                              label="WebPage Icon"
                            ></v-text-field>
                          </v-col>
                          <v-col class="d-flex" cols="12" sm="6">
                            <v-select
                              :items="webpagetagItems"
                              label="WEBPAGE TAG"
                              item-text="tagname"
                              item-value="tagId"
                              v-model="editedItem.webpagetagId"
                            ></v-select>
                          </v-col>
                          <v-col cols="12" sm="6" md="6">
                            <v-text-field
                              v-model="editedItem.webpageid"
                              label="WebPage Id"
                              v-if="!hide"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" text @click="close"
                        >Cancel</v-btn
                      >
                      <v-btn color="blue darken-1" text @click="save"
                        >Save</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
              <v-icon small @click="deleteItem(item)">delete</v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'

export default {
  name: 'WebPage',
  data: () => ({
    search: '',
    dialog: false,
    loading: true,
    hide: true,
    headers: [
      { text: 'WEBPAGE ID', value: 'webpageid' },
      { text: 'WEBPAGE NAME', value: 'webpagename' },
      { text: 'WEBPAGE URL', value: 'webpageurl' },
      { text: 'WEBPAGE ICON', value: 'webpageicon' },
      { text: 'WEBPAGE TAG', value: 'webpagetag' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    webpages: [],
    webpagetagItems: [],
    editedIndex: -1,
    editedItem: {
      webpageid: 0,
      webpagename: ''
    },
    defaultItem: {
      webpageid: 0,
      webpagename: ''
    }
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      this.submitBtnLoading = true
      ApiService.get('/WebPage')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.webpages = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })

      ApiService.get('/WebpageTag')
        .then(res => {
          if (res.data.isauthenticated) {
            if (res.data.success) {
              this.webpagetagItems = res.data.respond
              this.loading = false
            } else {
              this.$swal('', res.data.error, 'error')
              this.loading = false
            }
          } else {
            this.loading = false
            return this.$router.push({ name: 'home' })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },

    editItem(item) {
      this.editedIndex = this.webpages.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      const index = this.webpages.indexOf(item)
      confirm('Are you sure you want to delete this item?') &&
        this.webpages.splice(index, 1)
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    save() {
      if (this.editedIndex > -1) {
        let webpagename = this.editedItem.webpagename
        let webpageurl = this.editedItem.webpageurl
        let webpageicon = this.editedItem.webpageicon
        let WebpageId = this.webpages[this.editedIndex].webpageid
        let webpagetagId = this.editedItem.webpagetagId
        let parent = this
        ApiService.put('/WebPage/' + WebpageId, {
          webpagename,
          webpageurl,
          webpagetagId,
          webpageicon
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.initialize()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
        Object.assign(this.webpages[this.editedIndex], this.editedItem)
      } else {
        let webpagename = this.editedItem.webpagename
        let webpageurl = this.editedItem.webpageurl
        let webpagetagId = this.editedItem.webpagetagId
        let webpageicon = this.editedItem.webpageicon
        let parent = this
        ApiService.post('/WebPage', {
          webpagename,
          webpageurl,
          webpageicon,
          webpagetagId
        }).then(res => {
          if (res.data.success) {
            this.$swal('', res.data.respond, 'success').then(function() {
              parent.initialize()
              parent.btnLoading = false
            })
          } else {
            this.btnLoading = false
            this.$swal('', res.data.error, 'error')
          }
        })
      }
      this.close()
    }
  }
}
</script>
